<template>
  <a-popconfirm
    :title="'supported-networks.icon-remove-quest' | globalize"
    :ok-text="'supported-networks.icon-remove-answer-yes' | globalize"
    :cancel-text="'supported-networks.icon-remove-answer-no' | globalize"
    @confirm="onClick"
  >
    <a-button
      v-ripple
      :title="'supported-network-editor.btn-remove' | globalize"
      type="default"
    >
      <i class="mdi mdi-trash-can-outline" />
    </a-button>
  </a-popconfirm>
</template>

<script>
import AButton from 'ant-design-vue/lib/button'
import APopConfirm from 'ant-design-vue/lib/popconfirm'

export default {
  name: 'delete-supported-network',
  components: {
    AButton,
    'a-popconfirm': APopConfirm,
  },
  props: {
    onClick: {
      type: Function,
      default: () => {},
    },
  },
}
</script>

<style lang="scss" scoped>
  @import '~ant-design-vue/lib/button/style/index.css';
  @import '~ant-design-vue/lib/popover/style/index.css'

</style>
